// Bugsnag
import Bugsnag from '@bugsnag/js'
import BugsnagPerformance, { DefaultRoutingProvider } from '@bugsnag/browser-performance'

// myUMBC environment and version
function getMetaContent(name) {
    const meta = document.querySelector(`meta[name="${name}"]`)
    return meta ? meta.getAttribute('content') : null
}

const myumbcEnvironment = getMetaContent('myumbc:environment') || 'production'
const myumbcVersion = getMetaContent('myumbc:version') || 'unknown'

// Profile sections to normalize
const profileSections = new Set([
  'notifications', 'graduation', 'degree', 'registration', 'grades',
  'blackboard', 'billing', 'financialaid', 'campuscard', 'careercenter',
  'parking', 'about'
]);

// Custom routing for parameterized routes
const resolveRoute = (url) => {
  // Defensive: ensure url is an object with pathname
  if (!url || typeof url.pathname !== 'string') return '/';

  const pathname = url.pathname.trim();

  // Normalize /account/invite/:invitation
  if (pathname.startsWith('/account/invite')) {
    return '/account/invite/:invitation';
  }

  // Normalize /profile/:section
  if (pathname.startsWith('/profile')) {
    const parts = pathname.split('/').filter(Boolean); // removes empty strings
    const section = parts[1] && profileSections.has(parts[1]) ? parts[1] : '';
    return section ? `/profile/${section}` : '/profile';
  }

  // Default: return original pathname
  return pathname;
};

Bugsnag.start({
    apiKey: 'd81a991c4d14f69c669c983c6ac77fd0',
    releaseStage: myumbcEnvironment,
    appVersion: myumbcVersion
})

BugsnagPerformance.start({
    apiKey: '6af745cb1e8314dc8c0004b36e38c653',
    releaseStage: myumbcEnvironment,
    appVersion: myumbcVersion,
    bugsnag: Bugsnag,
    serviceName: 'myUMBC',
    autoInstrumentRouteChanges: false,
    routingProvider: new DefaultRoutingProvider(resolveRoute)
})

// This is the Javascript one -- can only have one active at a time
// BugsnagPerformance.start({ apiKey: 'd81a991c4d14f69c669c983c6ac77fd0' })

// console.log('Resolved route:', resolveRoute(window.location));
